import React from 'react';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import {projects, projects2} from './pages/Projects/data';

function App() {
  return (
    <div className="w-full">
      <NavBar />
      <About />
      <Projects title="Proyectos personales" projects={projects} />
      <Projects
        title="Proyectos en los que he trabajado"
        projects={projects2}
      />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
